import {  DOSSIER_FILTER_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"




export const getAll = ({ commit },params) => {
    // const url = IA_CLASSIFICATION_API
    const url = DOSSIER_FILTER_API
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null,params:{...params,}, method: "GET" }).then(({ data }) => {
        const response = data?.data ?? data
        commit(types.SET_ITEMS, response)
        commit(types.SET_PAGINATION, {...data,data:null})
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_PAGINATION, {})
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
      
    })
}

export const resetData = ({ commit }) => {
    commit(types.RESET)
}



